<template>
	<div class="login">
		<div class="login-logo">
			<a href="/">
				<img src="../assets/logo4.png" />
			</a>
		</div>
		<div class="container">
			<h3>欢迎使用</h3>
			<div class="content-wrapper">
				<div class="form-title">CloudLinker 账号登录</div>
				<el-form :model="loginForm" ref="loginForm" :rules="rules" :show-message="false">
					<div class="list-group">
						<el-form-item class="list-group-item" prop="domain">
							<el-input type="text" v-model.trim="loginForm.domain" placeholder="团队ID" @blur="checkCaptcha"> </el-input>
						</el-form-item>
						<el-form-item v-if="!ssoOption.is_open_sso || (ssoOption.is_open_sso && ssoOption.is_account_password)" class="list-group-item" prop="username">
							<el-input type="email" v-model.trim="loginForm.username" placeholder="账号/邮箱" @blur="checkCaptcha"> </el-input>
						</el-form-item>
						<el-form-item v-if="!ssoOption.is_open_sso || (ssoOption.is_open_sso && ssoOption.is_account_password)" class="list-group-item" prop="password">
							<el-input type="password" v-model="loginForm.password" placeholder="密码" @keyup.enter.native="onKeyup()"> </el-input>
						</el-form-item>
						<el-form-item prop="captcha" v-if="showCaptcha">
							<el-col :span="16">
								<el-input required="required" v-model="loginForm.captcha" placeholder="验证码" class="form-control" @keyup.enter.native="onKeyup()"> </el-input>
							</el-col>
							<el-col :span="8" class="send-code">
								<img :src="captchaSrc" alt="" style="width: 100%; height: 32px; margin-top: 2px" @click="refresh()" />
							</el-col>
						</el-form-item>
					</div>

					<div class="agree">
						<el-checkbox v-model="loginForm.agree"> </el-checkbox>
						我已阅读并同意
						<!-- 可点击的协议链接 -->
						<a href="/console.html#/user-agreement" target="_blank" class="link">用户协议</a>、
						<a href="/console.html#/privacy-policy" target="_blank" class="link">隐私政策</a>
					</div>

					<el-form-item v-if="!ssoOption.is_open_sso || (ssoOption.is_open_sso && ssoOption.is_account_password)">
						<el-button @click="login(loginForm)" class="btn" type="primary" :disabled="loginForm.domain != '' && loginForm.username != '' && loginForm.password != '' && loginForm.agree ? false : true">
							<span v-if="!loading">登录</span>
							<span v-if="loading">
								<span>登录中</span>
								<i class="el-icon-loading"></i>
							</span>
						</el-button>
					</el-form-item>

					<el-form-item v-if="ssoOption.is_open_sso">
						<el-button @click="ssoLogin()" class="btn" :disabled="!loginForm.agree">
							<span>使用SSO登录</span>
						</el-button>
					</el-form-item>

					<div class="capitalize clearfix">
						<div class="but">
							<router-link to="forgetpsw" class="pull-right login-link">忘记密码?</router-link>
							<router-link to="register" class="pull-right login-link">立即注册</router-link>
						</div>
						<!--a.pull-right(ui-sref="signup" translate) sign up an company-->
					</div>
				</el-form>
			</div>
		</div>
		<div class="copyright clearfix small">
			<div>Copyright 上海驻云信息科技有限公司</div>
			<div>
				Powered by
				<a href="https://www.cloudcare.cn" target="_blank" class="text-primary new-block">cloudcare.cn</a>
			</div>
		</div>
	</div>
</template>
<script>
import STORE_CONST from '../store/consts'
import axios from 'axios'
import { baseUrl } from '../config'
import { t } from 'element-ui/lib/locale'
export default {
	name: 'login',
	data() {
		return {
			compelChangePassword: false,
			loginForm: {
				domain: '',
				username: '',
				password: '',
				captcha: '',
				agree: false,
			},
			ssoOption: {
				is_open_sso: false,
				mfa: false,
				is_account_password: false,
				sso_service: '',
			},
			showCaptcha: 0,
			currentAccount: this.$store.getters.current,
			captchaSrc: baseUrl.apiUrl + '/auth/captcha' + '?' + new Date().getTime(),
			loading: false,
			canSubmit: false,
			rules: {
				domain: [
					{
						required: true,
						trigger: 'blur',
					},
				],
				username: [
					{
						required: true,
						trigger: 'blur',
					},
				],
				password: [
					{
						required: true,
						trigger: 'blur',
					},
				],
				captcha: [
					{
						required: true,
						trigger: 'blur',
					},
				],
			},
		}
	},
	created() {
		// this.isLogin()
		this.$store.dispatch(STORE_CONST.ACCOUNT.CURRENT).then((res) => {
			if (res.is_admin) {
				this.$router.push('/dashboard')
				sessionStorage.setItem('activeIndex', '1-1')
			} else if (res.error_message) {
				console.log(res, 'res')
			} else {
				this.$router.push('/operation/workgroup')
				sessionStorage.setItem('activeIndex', '1-2')
			}
		})
	},
	methods: {
		onKeyup() {
			if (this.canSubmit) {
				this.login()
			}
		},
		checkCaptcha() {
			console.log(this.$refs['loginForm'].validateField('username'))
			this.$refs['loginForm'].validateField('domain', (res) => {
				console.log('res', res)
				if (!res) {
					this.checkSSO()
					this.$refs['loginForm'].validateField('username', (r) => {
						if (!r) {
							let params = {
								domain: this.loginForm.domain,
								username: this.loginForm.username,
							}
							this.$store.dispatch(STORE_CONST.ACCOUNT.SHOW_CAPTCHA, params).then(
								(res) => {
									this.showCaptcha = res.captcha
									if (this.showCaptcha) {
										this.refresh()
									}
								},
								() => {
									this.showCaptcha = 0
								}
							)
						}
					})
				}
			})
		},
		async checkSSO() {
			let params = {
				domain: this.loginForm.domain,
			}
			this.$store.dispatch(STORE_CONST.ACCOUNT.CHECK_SSO, params).then(
				(res) => {
					console.log(res, 'res')
					this.ssoOption = {
						is_open_sso: res.is_open_sso,
						mfa: res.mfa,
						is_account_password: res.is_account_password,
						sso_service: res.sso_service,
					}
					console.log(this.ssoOption, 'ssoOption')
				},
				() => {
					this.$notify({
						type: 'error',
						message: this.$gettext('Check SSO Failed'),
					})
				}
			)
		},

		login(m) {
			this.loading = true
			this.$store
				.dispatch(STORE_CONST.ACCOUNT.LOGIN, {
					data: this.loginForm,
				})
				.then(
					(res) => {
						this.loading = false
						if (res.otp_enabled) {
							this.$router.push('/mfaComfirm')
						} else if (res.op == 'change_pwd') {
							this.$router.push('/compelChangePassword')
						} else if (res.company_mfa && !res.otp_enabled) {
							this.$router.push('/mfaOpen')
						} else {
							localStorage.setItem('isAdmin', res.is_admin)
							this.$store
								.dispatch(STORE_CONST.TEAM.CURRENT)
								.then((team) => {
									if (team.current_plan === null) {
										this.$router.push('/purchase')
									} else {
										if (res.is_admin) {
											this.$router.push('/dashboard')
											sessionStorage.setItem('activeIndex', '1-1')
										} else {
											this.$router.push('/operation/workgroup')
											sessionStorage.setItem('activeIndex', '1-2')
										}
									}
									this.$notify({
										message: this.$gettext('Login Successfully!'),
										type: 'success',
									})
								})
								.catch((err) => {
									this.$notify({
										type: 'error',
										message: this.$gettext(err.code),
									})
								})
						}
					},
					(err) => {
						console.log(err)
						// 解决连续登陆不出现验证码bug
						if (err.code === 'CaptchaIncorrect') {
							this.showCaptcha = 1
						}
						// 图形验证码存在的情况下登录失败刷新图形验证码
						if (this.showCaptcha) {
							this.refresh()
						}
						this.loading = false
					}
				)
		},
		ssoLogin() {
			if (this.ssoOption.sso_service) {
				window.location.href = this.ssoOption.sso_service
			}
		},
		isLogin() {
			if (!Object.isEmpty(this.$store.getters.account)) {
				this.$router.push('/dashboard')
			}
		},
		refresh() {
			this.captchaSrc = baseUrl.apiUrl + '/auth/captcha' + '?' + new Date().getTime()
		},
	},
	watch: {
		loginForm: {
			handler: function (newVal, oldVal) {
				const that = this
				if (this.$refs['loginForm']) {
					this.$refs['loginForm'].validate(function (valid) {
						that.canSubmit = valid
					})
				}
			},
			deep: true,
		},
	},
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.container {
	height: 390px;
}

.container ul {
	list-style-type: none;
	padding: 0;
}

.container .but {
	display: flex;
	justify-content: space-between;
}

.login {
	.form-title {
		font-size: 20px;
		font-weight: bold;
		padding: 10px 0;
		margin-top: 20px;
		color: #000;
	}
	.el-form {
		width: 300px;
		margin: 10px auto 30px;

		.el-form-item {
			margin-bottom: 8px;

			.el-input__inner {
				height: 32px;
			}

			&.is-error {
				.el-input {
					.el-input__inner {
						border-color: #bfcbd9 !important;
					}
				}
			}
		}

		.form-control {
			font-size: 14px;
		}

		.btn {
			width: 100%;
			font-size: 16px;
			border-radius: 0;
		}
		.agree {
			text-align: left;
			font-size: 12px;
			margin-bottom: 5px;
			a {
				color: #0069ff;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// login.vue?034b4ae4